import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAdmin, getCurrentUser } from "../../services/authService";

const AdminRoute = (props) => {
  const { path, component: Component, render, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!getCurrentUser()) {
          return <Redirect to="/login" />;
        } else if (!isAdmin()) {
          return <Redirect to="/unauthorized" />;
        } else {
          return Component ? <Component {...props} /> : render(props);
        }
      }}
    />
  );
};

export default AdminRoute;
